import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CountryData } from '../../types/game';

interface GoogleMapsAndWikipediaButtonsProps {
  country: CountryData | undefined;
}

export function GoogleMapsAndWikipediaButtons({
  country,
}: GoogleMapsAndWikipediaButtonsProps) {
  const { i18n } = useTranslation();

  const googleMapsUrl = useMemo(() => {
    if (!country?.links)
      return `https://www.google.com/maps/place/${country?.name}/@${country?.latitude},${country?.longitude},11z&hl=${i18n.resolvedLanguage}`;
    return country.links
      .find((link) => link.type === 'GoogleMaps')
      ?.url.replace('${cc}', 'en');
  }, [country, i18n.resolvedLanguage]);

  const wikipediaUrl = useMemo(() => {
    if (!country?.links)
      return `https://${i18n.resolvedLanguage}.wikipedia.org/wiki/${country?.name}`;
    return country.links
      .find((link) => link.type === 'Wikipedia')
      ?.url.replace('${cc}', 'en');
  }, [country, i18n.resolvedLanguage]);

  return (
    <div className="flex flex-row gap-4">
      <a
        className="flex h-10 w-10 border rounded-xl px-1 text-center items-center justify-center font-semibold whitespace-nowrap hover:bg-gray-200 hover:dark:bg-gray-500"
        href={wikipediaUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/images/icons/wikipedia.png"
          alt="wikipedia"
          className="w-8"
        />
      </a>
      <a
        className="flex h-10 w-10 border rounded-xl px-1 text-center items-center justify-center font-semibold whitespace-nowrap hover:bg-gray-200 hover:dark:bg-gray-500"
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/images/icons/googleMaps.png"
          alt="wikipedia"
          className="w-8"
        />
      </a>
    </div>
  );
}
